import React, { PropsWithChildren } from 'react';

import { Component, Hanger } from '@paragon/contract-library';

import { useAppDispatch, useAppSelector } from '../../components/hooks';
import { clearHoverItemIfActive, ensureHoverItemIsActive } from '../../store/actions/viewportActions';
import { getHangerViewStatus } from '../../store/selectors/viewStatusSelectors';
import { HangerVisual } from '../layout/HangerVisual';

export function ComponentHangersContainer(props: { component: Component }) {
  const hangerViewStatus = useAppSelector(getHangerViewStatus);
  return props.component.hangers.map((hanger) => (
    <HangerEventHandlers key={hanger.guid} component={props.component} hanger={hanger}>
      <HangerVisual
        key={hanger.guid}
        mode="Girder Design"
        hanger={hanger}
        component={props.component}
        wireframe={hangerViewStatus(hanger) === 'Wireframe'}
      />
    </HangerEventHandlers>
  ));
}

function HangerEventHandlers(props: PropsWithChildren<{ component: Component; hanger: Hanger }>) {
  const dispatch = useAppDispatch();

  const interactionHandle = { type: 'hanger', guid: props.hanger.guid, origin: 'fiber' } as const;

  return (
    <group
      onPointerOver={(event) => {
        event.stopPropagation();
        dispatch(ensureHoverItemIsActive(interactionHandle));
      }}
      onPointerOut={() => {
        dispatch(clearHoverItemIfActive(interactionHandle));
      }}
    >
      {props.children}
    </group>
  );
}
